if (!customElements.get("ef-cart-terms")) {
  customElements.define(
    "ef-cart-terms",
    class CartTerms extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.cartDetails = this.closest(".cart-details");
        this.error = this.querySelector("[data-terms-error]");
        if (!this.checkbox || !this.cartDetails) return;

        this.checkoutButton = this.cartDetails.querySelector(
          'button[name="checkout"]',
        );
        this.acceleratedCheckout = this.cartDetails.querySelector(
          ".additional-checkout-buttons",
        );

        this.checkbox.addEventListener("change", () => this.update());
        this.checkoutButton?.addEventListener("click", (event) => {
          if (this.checkbox.checked) return;
          event.preventDefault();
          this.showError();
        });
        this.update();
      }

      update() {
        const accepted = this.checkbox.checked;
        if (this.checkoutButton) {
          this.checkoutButton.disabled = !accepted;
          this.checkoutButton.setAttribute("aria-disabled", String(!accepted));
        }
        if (this.acceleratedCheckout) {
          this.acceleratedCheckout.classList.toggle(
            "ef-terms-locked",
            !accepted,
          );
          this.acceleratedCheckout.setAttribute(
            "aria-hidden",
            String(!accepted),
          );
        }
        if (accepted) {
          this.classList.remove("has-error");
          if (this.error) this.error.hidden = true;
        }
      }

      showError() {
        this.classList.add("has-error");
        if (this.error) this.error.hidden = false;
        this.checkbox.focus();
      }
    },
  );
}

if (!window.__efCartTermsSubmitGuard) {
  window.__efCartTermsSubmitGuard = true;
  document.addEventListener(
    "submit",
    (event) => {
      const checkoutButton = event.submitter;
      if (!checkoutButton || checkoutButton.name !== "checkout") return;
      const cartDetails = checkoutButton.closest(".cart-details");
      const terms = cartDetails?.querySelector("ef-cart-terms");
      if (!terms?.checkbox || terms.checkbox.checked) return;
      event.preventDefault();
      terms.showError();
    },
    true,
  );
}
